import axios from 'axios'

export const state = {
  customPayments: [],
}

export const getters = {
  getCustomPayments(state) {
    return state.customPayments
  },
}

export const mutations = {
  SET_CUSTOM_PAYMENTS(state, newValue) {
    state.customPayments = newValue
  },
}

export const actions = {
  insertCustomPaymentDocument({ commit, state }, { params: customPaymentDetails }) {
    return axios.post(`v1/customPayments/`, customPaymentDetails).then(response => {
      return response.data
    })
  },
  updateCustomPaymentDocument({ commit, state }, { params: customPaymentObj }) {
    return axios.put(`v1/customPayments/`, customPaymentObj.doc).then(response => {
      return response.data
    })
  },
  fetchCustomPaymentDocument({ commit, state }, { groupId, outlets }) {
    let params = {
      group_id: groupId,
      outlets: outlets,
    }
    return axios.get(`v1/customPayments/`, { params: params }).then(response => {
      return response.data
    })
  },
}
